interface CTASectionProps {
  onGetStarted: () => void;
}

export default function CTASection({ onGetStarted }: CTASectionProps) {
  return (
    <section className="py-24 bg-primary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-8">Ready to transform your accounting?</h2>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button 
            onClick={onGetStarted}
            className="bg-white text-primary hover:bg-slate-100 font-bold px-8 py-4 rounded-xl transition-all shadow-xl"
          >
            Start Free Trial
          </button>
          <button className="bg-primary-dark text-white border border-white/20 hover:bg-primary-dark/80 font-bold px-8 py-4 rounded-xl transition-all">
            Contact Sales
          </button>
        </div>
      </div>
    </section>
  );
}
